.root {
  flex: 1 1 auto;
  min-width: 0;
  margin-top: 4px;
  margin-bottom: 4px;
}

.multiline {
  margin-top: 6px;
  margin-bottom: 6px;
}

.dense {
}

.inset {
  padding-left: 56px;
}

.primary {
}

.secondary {
}
